import createWhitelistFilter from "redux-persist-transform-filter";
import { FETCH_BENEFICIARY_ERROR, UPDATE_BENEFICIARY } from "../actions/Common";

const initialState = {
  fetchBeneficiaryPending: false,
  fetchBeneficiaryError: null,
  beneficiary: null,
  lastBeneficiaryUpdateTs: new Date().getTime()
};

export const beneficiaryPersistTransform = () => {
  return createWhitelistFilter("beneficiaries", ["beneficiary", "lastBeneficiaryUpdateTs"]);
};

export function beneficiaryReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_BENEFICIARY: {
      return {
        ...state,
        beneficiary: action.beneficiary,
        fetchBeneficiaryPending: false,
        fetchBeneficiaryError: null,
        lastBeneficiaryUpdateTs: new Date().getTime()
      };
    }
    case FETCH_BENEFICIARY_ERROR: {
      return state;
    }
    default:
      return state;
  }
}

export const beneficiarySelector = state => {
  return state.beneficiaries.beneficiary || null;
};

export const lastBeneficiaryUpdateTsSelector = state => {
  return state.beneficiaries.lastBeneficiaryUpdateTs;
};
